export const DEFAULT_VAPI_AGENT_ID = '74af3b57-be80-438f-ab56-8e07161b3e62';

/** Legacy ElevenLabs default from DB migrations — replaced via Vapi sync */
export const LEGACY_DEFAULT_VOICE_ID = 'LaA6M5cUQto6DNKrNMXO';
